<p>
  <span>{{'BOOKING_MODULE.CHANGE_CANCEL_POLICIES.CHANGES' | transloco}}: </span>
  <span>{{ buildLabelForChanges() }}</span>
</p>
